import { AgentRunLogsTab } from '../../components/AgentRunLogsTab';

export function SuperadminAgentRuns() {
  return <AgentRunLogsTab />;
}
